import React, { Component } from "react";
import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet";
import "../Style.scss";

export class Disclaimer extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>Disclaimer ~ Algoquant Global</title>
        </Helmet>
        <div className="wrapper disclaimerContainer">
          <div className="disclaimerHeader container headerforall">
            <div className="leftHeader">
              <h1>DISCLAIMER</h1>
            </div>
            <div className="rightHeader">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a href="/" className="inActive">
                      Home
                    </a>
                  </li>
                  <li class="breadcrumb-item active" aria-current="page">
                    Disclaimer
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <hr width="100%" />
          <Container className="disclaimer paragraphforall">
            <p className="disc">
              All reasonable care has been taken to ensure that the information
              contained herein is not misleading or untrue at the time of
              publication. However, we make no long standing commitment as to
              its accuracy or completeness. All information is for the private
              use of the person to whom it is provided without any liability
              whatsoever on the part of Algoquant Global or any
              associated company or any member of employee thereof.
            </p>
            <p className="disc">
              Algoquant Global may have open and investment
              interest in the stocks mentioned herein. Nothing contained herein
              should be construed as an offer to buy or sell or a solicitation
              of an offer to buy or sell. The value of any investment may fall
              as well as rise. Investors are advised to avail personal
              counseling from our research or dealing desk if they wish for any
              further clarity or clarifications in the understanding on various
              aspects of investment.
            </p>
            <p className="disc">
              Algoquant Global has taken due care and caution in
              compilation of data for its web site. The views and investment
              tips expressed by investment experts on Algoquant Global Private
              Limited are their own, and not that of the site. Algoquant Global
              Private Limited advices users to check with certified experts
              before taking any investment decision. However, Algoquant Global
              Private Limited does not guarantee the accuracy, adequacy or
              completeness of any information and is not responsible for any
              errors or omissions or for the results obtained from the use of
              such information. Algoquant Global especially states
              that it has no financial liability whatsoever to any user on
              account of the use of information provided on its website.
            </p>
          </Container>
        </div>
      </>
    );
  }
}

export default Disclaimer;
